import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import { SIDEBAR_COLORS } from '@/common/presentation/constants/colors';

export const NavUserWrapper = styled('div')<{ sidebarOpen: boolean }>(({ sidebarOpen }) => ({
  cursor: 'pointer',
  bottom: 0,
  position: 'relative',
  paddingLeft: sidebarOpen ? '1rem' : '0',
  paddingBottom: '1rem',
  paddingRight: '1rem',
  backgroundColor: SIDEBAR_COLORS.BACKGROUND,
  zIndex: 2000
}));

export const NavUserAvatar = styled(Avatar)(({ theme }) => ({
  width: '2.125rem',
  height: '2.125rem',
  background: SIDEBAR_COLORS.AVATAR_BACKGROUND,
  color: theme.palette.common.black,
  fontSize: '0.75rem',
  fontWeight: 600
}));

export const NavUserNameTypography = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.common.white,
  fontWeight: 600,
  lineHeight: '1.5rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 144
}));

export const NavUserRoleTypography = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.grey[400],
  fontWeight: 400,
  lineHeight: '1.25rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 144
}));

export const NavUserNameWrapper = styled('div')({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});

export const NavUserWrapperContentAvatarWrapper = styled('div')<{ sidebarOpen: boolean }>(({ sidebarOpen }) => ({
  display: 'flex',
  gap: '1rem',
  justifyContent: sidebarOpen ? 'flex-start' : 'center',
  alignItems: 'center',
  paddingLeft: sidebarOpen ? '0.5rem' : '0',
  paddingTop: '1rem'
}));

export const NavUserWrapperContent = styled('div')<{ sidebarOpen: boolean }>(({ sidebarOpen }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: !sidebarOpen ? '1rem' : '0'
}));
